import { render, staticRenderFns } from "./ViewRequests.vue?vue&type=template&id=5e94bb64&scoped=true&"
import script from "./ViewRequests.vue?vue&type=script&lang=js&"
export * from "./ViewRequests.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequests.vue?vue&type=style&index=0&id=5e94bb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e94bb64",
  null
  
)

export default component.exports